// import jquery from 'jquery';
import EFOcats_event_core from '../../../core/v1/event/efocats_event_core.js';

/**
 * 郵便番号自動入力イベント
 */
export default class EFOcats_event_retro_date extends EFOcats_event_core {
  init() {
    this.$('section').each((index, elem) => {
      const title = this.$(elem).find('.cat-txt').html();
      if (title && title.indexOf('希望日') !== -1) {
        const input = this.$(elem).find('input');
        this.$(elem).addClass('notfocus');
        input.parents('.check-flag').addClass('dateSetting ok-flag');
      }
    });
  }

  event() {
    this.$('section').each((index, elem) => {
      const title = this.$(elem).find('.cat-txt').html();
      if (title && title.indexOf('希望日') !== -1) {
        const input = this.$(elem).find('input');
        const name = input.attr('name');
        console.log(input);
        input.on('click', el => {
          document.querySelector(`[name=${name}]`).focus();
          document.querySelector('#ui-datepicker-div').style.display = 'block';
          const ptop = this.$(el.currentTarget).offset().top;
          const pleft = this.$(el.currentTarget).offset().left;
          document.querySelector('#ui-datepicker-div').style.top = `${ptop + 50}px`;
          document.querySelector('#ui-datepicker-div').style.left = `${pleft}px`;
          el.stopPropagation();
        });

        this.$('section').on('click', el => {
          if (document.querySelector('#ui-datepicker-div').style.display === 'block') {
            document.querySelector('#ui-datepicker-div').style.display = 'none';
          }
        });

        setInterval(() => {
          const val = document.querySelector(`[name=${name}]`).value;
          input.val(val);
        }, 500);
      }
    });

    // //////////////

    // if (this.$('.dateSetting input')) {
    //   const $ = jquery;
    //   require('jquery-ui/ui/widgets/datepicker');
    //   require('jquery-ui/ui/i18n/datepicker-ja');
    //   // カレンダーUiの起動
    //   this.$('.dateSetting input').datepicker({
    //     monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    //     monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    //     dateFormat: 'yy-mm-dd',
    //     dayNames: ['日', '月', '火', '水', '木', '金', '土'],
    //     dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    //     dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
    //     showMonthAfterYear: true,
    //     yearSuffix: '年',
    //   });
    // }

    // //////////////

    // if (this.$('.dateSetting input')) {
    //   require('jquery-ui/ui/widgets/datepicker');
    //   require('jquery-ui/ui/i18n/datepicker-ja');
    //   // calendar dateSetting
    //   const head = document.getElementsByTagName('head')[0];
    //   const link = document.createElement('link');
    //   link.setAttribute('rel', 'stylesheet');
    //   link.setAttribute('href', 'https://formcats.com/common/css/jquery-ui.css');
    //   head.appendChild(link);

    //   const style = '<link rel="stylesheet" href="https://formcats.com/common/css/jquery-ui.css">';
    //   this.$('head').append(style);

    //   const script1Timer = setInterval(() => {
    //     if (typeof jquery === 'function') {
    //       clearInterval(script1Timer);
    //       const script2 = '<script src="https://formcats.com/common/js/jquery-ui.min.js" charset="utf-8"></script>';
    //       this.$('head').append(script2);

    //       const script2Timer = setInterval(() => {
    //         if (typeof this.$('.dateSetting input').datepicker === 'function') {
    //           clearInterval(script2Timer);
    //           console.log(this.$('.dateSetting input'));
    //           console.log(this.$('.dateSetting input').datepicker);
    //           // カレンダーUiの起動
    //           this.$('.dateSetting input').datepicker({
    //             monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    //             monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    //             dateFormat: 'yy-mm-dd',
    //             dayNames: ['日', '月', '火', '水', '木', '金', '土'],
    //             dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
    //             dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
    //             showMonthAfterYear: true,
    //             yearSuffix: '年',
    //           });
    //         }
    //       }, 100);
    //     }
    //   }, 100);
    // }
  }
}
